export default "./images/logo-kroezon.png";